/**
 * useCookies - An SSR safe hook to provide the Cookies API.
 */
import {useMemo} from "react";

import {RenderState, useRenderState} from "@khanacademy/wonder-blocks-core";

import type {CookiesAPI} from "./api-type.ts";
import * as Cookies from "./cookies-api.ts";

/**
 * React hook providing access to the Cookies API in an SSR-safe manner.
 */
export const useCookies = (): CookiesAPI | null => {
    const renderState = useRenderState();

    return useMemo(() => {
        // Wait until after the initial render on the client to check whether
        // the feature flag is set or not. This prevents rehydration errors.
        if (renderState === RenderState.Standard) {
            return Cookies;
        }
        return null;
    }, [renderState]);
};
